var map = {
	"./Sam_Kier_Suit.jpeg": 510,
	"./Samuel_Kier_Resume_2025.pdf": 919,
	"./discord_logo.png": 106,
	"./dotData_logo.png": 377,
	"./heartland_logo.jpg": 411,
	"./lecturesphere_logo.png": 37,
	"./mlb_logo.png": 751,
	"./sam_bascom.jpeg": 446,
	"./sam_italy2.jpg": 949,
	"./sciswift_logo.jpg": 548,
	"./sts_logo.png": 750,
	"./uw_logo.png": 428
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;